export default "__VITE_ASSET__mkZKazoI__"